/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { PartnerService } from '../../services/partner.service';
import { Constants, Partner } from '../constants';

@Component({
  selector: 'partner-picker',
  templateUrl: './partner-picker.component.html',
  styleUrls: ['./partner-picker.component.scss']
})
export class PartnerPickerComponent implements OnInit {

  @Input()
  selectedPartner: Partner;

  @Input()
  options: PartnerPickerOptions;

  @Output('onChange')
  onChange: EventEmitter<Partner> = new EventEmitter<Partner>();

  partners: Array<Partner>;

  constructor(private constants: Constants,
              private partnerService: PartnerService) { }

  ngOnInit() {
    this.partnerService.getPartners().subscribe(
      (result: any) => {
        this.partners = result;
      },
      error => {
        // TODO
      }
    )
  }

  selectPartner(p) {
    if (p != this.selectedPartner) {
      this.selectedPartner = p;
      this.onChange.emit(this.selectedPartner);
    }
  }
}

export interface PartnerPickerOptions {
  selectDefaultWhenOne: boolean;  // when there is only a single valid partner, automatically pick it
}



// WEBPACK FOOTER //
// ./client/app/global/partner-picker/partner-picker.component.ts